module.exports = __webpack_public_path__ + "img/documents_sheets_view.1e9db8ea.svg";